<template>
  <el-header class="header">
    <div class="left-menu">
      <div class="logo-container">
        <!-- <img src="../../images/logo.png" class="logo-img" /> -->
        <div class="logo-title">{{ title }}</div>
      </div>
      <Hamburger />
    </div>
    <div class="center-menu">
      <Nav :navData="state.navData" />
    </div>
    <div class="right-menu">
      <div class="extra-right-menu">
        <slot name="right-menu"></slot>
      </div>
      <el-dropdown style="margin-right: 10px" trigger="hover" placement="bottom">
        <el-icon style="font-size: 26px"><Link /></el-icon>
        <template #dropdown>
          <el-dropdown-menu class="user-dropdown">
            <el-dropdown-item>
              <div
                @click="
                  downFile(
                    'https://file.dev.zrshuiwu.com/group1/zr-dev/default/template/20250710/14/47/7/AVITOMP4TOOL.exe'
                  )
                "
              >
                AVI转MP4工具
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="downFile('https://file.dev.zrshuiwu.com/group1/zr-dev/default/template/视频上传工具.zip')">
                视频上传工具
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <el-tooltip v-if="!hiddenAI" content="AI智能客服" placement="bottom">
        <img
          style="margin-right: 15px; cursor: pointer; width: 24px"
          src="./kefu.png"
          @click="state.isShowAiCustomerService = !state.isShowAiCustomerService"
        />
      </el-tooltip>
      <Transition name="slide-fade">
        <el-card v-if="state.isShowAiCustomerService" class="ai-customer-service">
          <template #header>
            <div style="text-align: right">
              <el-icon style="cursor: pointer" @click="state.isShowAiCustomerService = false"><Close /></el-icon>
            </div>
          </template>
          <iframe
            src="https://chat.dev.zrshuiwu.com/chat/share?shareId=mbjhngpifbb12dtaigqxaca8"
            style="width: 100%; height: 100%"
            frameborder="0"
            allow="*"
          />
        </el-card>
      </Transition>

      <el-tooltip
        v-if="
          auth &&
          (appStore.isRole(['admin']) ||
            appStore.isAuth('sys-role6') ||
            appStore.isAuth('sys-role1') ||
            appStore.isAuth('sys-role'))
        "
        content="系统管理"
        placement="bottom"
      >
        <img style="margin-right: 15px; cursor: pointer" src="./permissions_icon.png" @click="toSys" />
      </el-tooltip>
      <el-popover v-if="showQrCode && downloadUrl" placement="bottom" title="扫码下载App" :width="200" trigger="hover">
        <template #reference>
          <img src="./qrcode.png" style="margin-right: 10px; width: 20px" />
        </template>
        <qrcode-vue :value="downloadUrl" :size="170" level="H" />
      </el-popover>

      <el-dropdown class="avatar-container" trigger="hover" placement="bottom-start">
        <div class="avatar-wrapper">
          <img src="../../images/head_default_img.jpg" class="user-avatar" />
          <span class="user_name">{{ appStore.userInfo?.userInfo.fullName || '' }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <template #dropdown>
          <el-dropdown-menu class="user-dropdown">
            <el-dropdown-item>
              <div @click="state.isChangePasswordShow = true">修改密码</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="logout">退出登录</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

    <el-dialog
      :modelValue="showUpdatePassword"
      title="密码修改"
      width="25%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form ref="updatePasswordFormRef" :model="state.passwordChange" :rules="rule">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            key="oldPassword"
            v-model="state.passwordChange.oldPassword"
            type="password"
            show-password
            autocomplete="new-password"
            placeholder="旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            key="newPassword"
            v-model="state.passwordChange.newPassword"
            type="password"
            show-password
            autocomplete="new-password"
            placeholder="新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closeRestPassword">取 消</el-button>
          <el-button type="primary" @click="submitRestPassword">提 交</el-button>
        </div>
      </template>
    </el-dialog>
  </el-header>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import useAppStore from '@shared/store/useAppStore'
import { toLogin } from '@shared/utils'
import Hamburger from '../Hamburger'
import { updatePassword } from '@shared/apis/user'
import { sysLogout } from '@shared/apis/login'
import QrcodeVue from 'qrcode.vue'
import { Close, Link } from '@element-plus/icons-vue'
import Nav from './Nav'
import storage, { Permission_Routes, TOKEN_INFO } from '@/shared/utils/storage'
import { useRouter } from 'vue-router'
import { getAppList } from '@/shared/apis/appVersion'

const router = useRouter()
const auth = computed(
  () =>
    appStore.isAuth('sys-user') ||
    appStore.isAuth('sys-role') ||
    appStore.isAuth('sys-perm') ||
    appStore.isAuth('sys-area') ||
    appStore.isAuth('sys-work') ||
    appStore.isAuth('sys-application') ||
    appStore.isAuth('sys-app-version') ||
    appStore.isAuth('sys-message-config') ||
    appStore.isAuth('sys-audit-log')
)
const title = __SYS_CONFIG.systemName
const showQrCode = __SYS_CONFIG.systemKey !== 'GANZHOU'
const hiddenAI = __SYS_CONFIG.hiddenAI

const appStore = useAppStore()
const state = reactive({
  //修改密码弹窗
  isChangePasswordShow: false,
  passwordChange: {
    //修改密码参数
    redisUserID: '',
    oldPassword: '',
    newPassword: ''
  },
  timer: null,
  activeNavbar: '',
  navData: []
})

const updatePasswordFormRef = ref()
const downloadUrl = ref(null)

const { pwdUpdate } = storage.getItem(TOKEN_INFO)
const showUpdatePassword = computed(() => {
  if (pwdUpdate) return true
  return state.isChangePasswordShow
})

getAppList({
  pageIndex: 1,
  length: 1,
  appType: 1,
  status: 1,
  appName: '水环境'
}).then((res) => {
  if (res.content?.length) {
    const app = res.content[0]
    downloadUrl.value = `${window.location.origin}${
      import.meta.env.VITE_BASE_PATH
    }/downloadAPK?url=${appStore.joinOssUrl(app.ossId)}&appName=${app.appName}&version=${app.appVersion}`
  }
})

const validatePass = (rule, value, callback) => {
  if (!value.trim()) {
    return callback(new Error('新密码不能为空'))
  }
  if (value === state.passwordChange.oldPassword) {
    return callback(new Error('新密码不能与旧密码相同'))
  }
  return callback()
}
const downFile = (url) => {
  window.open(url)
}
//修改密码验证
const rule = {
  oldPassword: [{ required: true, message: '旧密码不能为空', trigger: 'blur' }],
  newPassword: [
    { required: true, validator: validatePass, trigger: 'change' },
    { pattern: /^.{6,20}$/, message: '密码长度应该为10-20位', trigger: 'blur' }
  ]
}

const submitRestPassword = () => {
  updatePasswordFormRef.value.validate((valid) => {
    if (!valid) return
    updatePassword(state.passwordChange).then(() => {
      ElMessage.success('密码修改成功')
      setTimeout(() => {
        closeRestPassword()
        logout()
      }, 3000)
    })
  })
}

const closeRestPassword = () => {
  //关闭密码修改表单
  updatePasswordFormRef.value.resetFields()
  state.isChangePasswordShow = false
}

const logout = () => {
  //退出登录
  sysLogout().then(() => {
    toLogin()
  })

  storage.setItem(Permission_Routes, null)
}
const toSys = () => {
  router.push(appStore.permissionRoutes[1].routes[0].children[0].path)
  let routeData = null
  if (storage.getItem(Permission_Routes)) {
    routeData = storage.getItem(Permission_Routes)?.map((item) => ({ ...item, showSystem: true }))
  }
  storage.setItem(Permission_Routes, routeData)
  state.navData = routeData || appStore.permissionRoutes
}

</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #dcdfe6;
}

.left-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 230px;
}

.center-menu {
  flex: 1;
  padding-left: 30px;
}

.right-menu {
  float: right;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .extra-right-menu {
    margin-right: 15px;
  }

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;

      .user_name {
        font-size: 14px;
        padding: 0 2px 0 5px;
        color: #409eff;
      }

      .user-avatar {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 50px;
        border: 2px solid #eee;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -14px;
        top: 10px;
        font-size: 12px;
      }
    }
  }
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;

  .logo-img {
    width: 32px;
    height: 32px;
    margin-right: 6px;
  }

  .logo-title {
    display: inline-block;
    margin: 0;
    line-height: 50px;
    white-space: nowrap;
    color: #1890ff;
    font-weight: 600;
    font-size: 14px;
    font-family:
      Avenir,
      Helvetica Neue,
      Arial,
      Helvetica,
      sans-serif;
    transition: 0.5s;
  }
}

.ai-customer-service {
  position: absolute;
  right: 20px;
  top: 50px;
  width: 700px;
  height: 700px;
  z-index: 10;
  :deep() {
    .el-card__body {
      width: 100%;
      height: calc(100% - 57px);
      padding: 0;
    }
  }
}

/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
